import { TransferType } from "../../models/transferType.enum";



export class TransactionDialogData {
    scheduled: boolean;
    value: number;
    transactionDate: string;
    description: string;
    bankName: string;
    favoredName: string;
    receiptId: number;
    transactionType: TransferType;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-response/models/transaction-dialog-data.ts